import React from 'react';

function Icons({type, data}) {
    const showDescription = (id, length) => {
        let idDescription = document.getElementsByClassName(id)[0];
        let serviceCellDescription = document.getElementsByClassName("serviceCell__description");
        
        if (idDescription.style.display === "none") {
            for (let i = 0; i < serviceCellDescription.length; i++) {
                serviceCellDescription[i].style.display = "none";
            }
            
            idDescription.style.display = "grid";
        }
        else {
            idDescription.style.display = "none";
        }
        
        if (length === 0) {
            idDescription.style.display = "none";
        }
    }
    
    return (
        <section className={`icons ${type}`}>
            {
                React.Children.toArray(
                    data.map(
                        (ele, id) => {
                            return (type === "servicesIcons") ? (
                                <div className="icons__cell serviceCell" onClick={() => showDescription(id, ele.text.length)}>
                                    <div className={`serviceCell__description ${id}`}>{ele.text}</div>
                                    <img src={ele.imageURL} alt="ICON" className="icons__cell__icon" data-aos="zoom-out" data-aos-delay="200" />
                                    <p className="icons__cell__name" data-aos="flip-down" data-aos-delay="300" >{ele.name}</p>
                                </div>
                            ) : (
                                <div className="icons__cell">
                                    <img src={ele.imageURL} alt="ICON" className="icons__cell__icon" data-aos="zoom-out" data-aos-delay="200" />
                                    <p className="icons__cell__name" data-aos="flip-down" data-aos-delay="300" >{ele.name}</p>
                                </div>
                            )
                        }
                    )
                )
            }
        </section>
    )
}

export default Icons
